import CommonService from "./common.service";
import superAdminApi from "./superAdminApi";

const isLogisticsManagerPortal = () =>
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/dashboard/logistics-manager");

function managerBase(rfqKind, path) {
  const prefix =
    rfqKind === "exhibition"
      ? "/logistics-manager/exhibition-logistics-rfqs"
      : "/logistics-manager/business-relocation-rfqs";
  return `${prefix}${path}`;
}

function superAdminBase(rfqKind, path) {
  const prefix =
    rfqKind === "exhibition"
      ? "/super-admin/logistics/exhibition-logistics-rfqs"
      : "/super-admin/logistics/business-relocation-rfqs";
  return `${prefix}${path}`;
}

export const extractApiMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export async function fetchLogisticsRfqUserAssignees(rfqKind = "business") {
  if (isLogisticsManagerPortal()) {
    const res = await CommonService.get(
      managerBase(rfqKind, "/logistics-user-assignees"),
      {},
      { silent: true },
    );
    return res?.data?.items ?? res?.items ?? [];
  }
  const res = await superAdminApi.get(superAdminBase(rfqKind, "/logistics-user-assignees"));
  return res.data?.data?.items ?? [];
}

export async function fetchLogisticsTeamSummary() {
  if (!isLogisticsManagerPortal()) {
    return { logisticsUserCount: 0, roundRobinEnabled: true };
  }
  const res = await CommonService.get("/logistics-manager/team-summary", {}, { silent: true });
  return {
    logisticsUserCount: Math.trunc(Number(res?.data?.logisticsUserCount) || 0),
    roundRobinEnabled: res?.data?.roundRobinEnabled !== false,
  };
}

export async function assignLogisticsRfqUser(rfqKind, rfqId, accessUserId) {
  const payload = { accessUserId: Math.trunc(Number(accessUserId)) };
  if (isLogisticsManagerPortal()) {
    const res = await CommonService.put(
      managerBase(rfqKind, `/${rfqId}/logistics-user-assignment`),
      payload,
    );
    return res?.data ?? res;
  }
  const res = await superAdminApi.put(
    superAdminBase(rfqKind, `/${rfqId}/logistics-user-assignment`),
    payload,
  );
  return res.data?.data ?? res.data;
}
